import React from "react";
import Rules, { RulesMode } from "@Front/Components/Elements/Rules";

import MenuItem, { IItem } from "./MenuItem";

type MenuSubMenuItemsProps = {
	items: IItem[];
	isSuperAdmin: boolean;
	close: () => void;
};

export function MenuSubMenuItems(props: MenuSubMenuItemsProps): React.JSX.Element {
	const { items, isSuperAdmin, close } = props;

	return (
		<>
			{items.map((item, index) => {
				const itemKey =
					typeof (item as { link?: string }).link === "string"
						? (item as { link: string }).link
						: `${item.text}-${index}`;
				if (isSuperAdmin) {
					return <MenuItem item={{ ...item, onClose: close }} key={itemKey} />;
				}
				return (
					<Rules mode={RulesMode.NECESSARY} rules={item.rules ?? []} key={itemKey}>
						<MenuItem item={{ ...item, onClose: close }} key={itemKey} />
					</Rules>
				);
			})}
		</>
	);
}
